import {
  Component,
  OnInit,
  OnChanges,
  SimpleChanges,
  Input,
  Output,
  EventEmitter,
  ElementRef
} from '@angular/core';

import * as d3 from 'd3';

@Component({
  selector: '[awair-mouse-event]',
  templateUrl: './mouse-event.component.html',
  styleUrls: ['./mouse-event.component.scss']
})

export class MouseEventComponent implements OnInit, OnChanges {

  @Input() width: number;
  @Input() height: number;

  @Output() hoverEvent: EventEmitter<any> = new EventEmitter();
  @Output() clickEvent: EventEmitter<any> = new EventEmitter();
  @Output() outEvent: EventEmitter<any> = new EventEmitter();

  private isInitialized: boolean = false;

  constructor(private el: ElementRef) { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    for (const propname in changes) {
      if (propname === 'width' || propname === 'height') {
        if (this.width !== null && this.height !== null) {
          if (this.isInitialized) {
            d3.select(this.el.nativeElement)
              .select('rect')
              .attr('width', this.width)
              .attr('height', this.height);

          } else {
            const coverage: any = d3.select(this.el.nativeElement)
              .select('rect')
              .attr('class', 'coverage')
              .style('fill', 'none')
              .style('pointer-events', 'all')
              // Again, this.width and this.height are actual work area that matches size of x&y axis
              .attr('width', this.width)
              .attr('height', this.height);
            coverage
              .on('mousemove', () => {
                const relativePos = {
                  x: d3.mouse(coverage.node())[0],
                  y: d3.mouse(coverage.node())[1]
                };
                this.hoverEvent.emit(relativePos);
              })
              .on('click', () => {
                this.clickEvent.emit();
              })
              .on('mouseout', () => {
                this.outEvent.emit();
              });

            this.isInitialized = true;
          }
        }
      }
    }
  }
}
